export default "__VITE_ASSET__VKkWIzXt__"